import React from 'react';
import About from './About';
import Banner from './Banner';
import Contact from './Contact';
import Portfolio from './Portfolio';
import Skills from './Skills';

const Home = () => {
    return (
        <div>
            <Banner />
            <Skills />
            <About />
            <Portfolio />
            <Contact />
        </div>
    );
};

export default Home;